<div class="container single-view" id="view-sale">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/sales" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SALES.BTN_BACK_TO_SALE' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="sale-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'SALES.VIEW_SALE_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (sale.item.product.name) {
                  <span data-testid='product-name'>{{ sale.item.product.name | defaultValue }}</span>
                }
                @if (sale.isReturned) {
                  <span data-testid="sale-isreturned" class="tag tag-red flex items-center">{{ 'ENUMS.RETURNED' | translate }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='sale-retailer' class="flex items-center mr-2" pTooltip="{{ 'SALE_SINGLE_VIEW.TOOLTIP_RETAILER' | translate }}" tooltipPosition="top"><i class="icon icon-retailer mr-1"></i>
            {{ sale.retailerName | defaultValue }}
          </span>

          @if (sale.unregisteredUserFullName) {
            <span data-testid='sale-seller' class="flex items-center mr-3" pTooltip="{{ 'SALE_SINGLE_VIEW.TOOLTIP_SELLER' | translate }}"
              tooltipPosition="top">
              <i class="icon icon-user mr-1"></i>
              {{ sale.unregisteredUserFullName | defaultValue }}
            </span>
          } @else {
            @if (sale.userFullName) {
              <span data-testid='sale-seller' class="flex items-center mr-3" pTooltip="{{ 'SALE_SINGLE_VIEW.TOOLTIP_SELLER' | translate }}"
                tooltipPosition="top">
                <i class="icon icon-user mr-1"></i>
                {{ sale.userFullName | defaultValue }}
              </span>
            }
          }


          <span data-testid='sale-saledate'  class="flex items-center mr-2" pTooltip="{{ 'SALE_SINGLE_VIEW.TOOLTIP_SALE_DATE' | translate }}" tooltipPosition="top"><i class="icon icon-calendar-tick mr-1"></i>
          {{ sale.date  | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
        </span>
      </div>
      <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3 mt-2">
        @if (canReturnCurrentSale) {
          <button data-testid='return-sale-btn' class="btn outline-btn" (click)="onTriggerSaleReturn($event)" [disabled]="sale.item.isStolen">{{ 'SALE_SINGLE_VIEW.BTN_RETURN_SALE' | translate }}</button>
        }
        @if (allowModifySale) {
          <button data-testid='edit-sale-btn' class="btn primary-btn" (click)="goToEditSale()" [disabled]="sale.isReturned == true || sale.item.isStolen">{{ 'SALE_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
        }
      </div>
    </div>
  </div>
  <hr role="presentation" class="w-full mb-3 mt-6 border-t">
  <div class="view-content-wr">
    <div class="row">
      <div class="flex flex-col col-12 mb-2 text-wr">
        <!-- main content -->
        <section class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-3">
            <img data-testid='sale-imageurl' src="{{ sale.item.product.imageUrl || sale.item.product.productTypeImageUrl }}" class="w-100 mt-2 mb-2 featured-image">
          </div>
          <div class="col-12 col-sm-12 col-md-8 col-lg-9">
            <h4 data-testid='sale-summary'>{{ 'SALE_SINGLE_VIEW.DETAILS' | translate }}</h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
            <dl class="details-grid">

              <dt data-testid='sale-brandname-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.BRAND' |
              translate }}</dt>
              <dd data-testid='sale-brandname' class="value pt-3 pb-3">
                {{ sale.item.product.brandName | defaultValue }}
              </dd>

              <dt data-testid='sale-serialnumber-label' data-testid='sale-serialnumber-label' class="label grid-cols-1 pt-3">{{
              'SALE_SINGLE_VIEW.SERIAL_NUMBER' | translate }}</dt>
              <dd data-testid='sale-serialnumber' class="value pt-3 pb-3">
                @if (sale.item.serialNumber && allowViewItem) {
                  <a [routerLink]="['/items/', sale.item.id]" class="inline-flex items-center link">{{ sale.item.serialNumber |
                  defaultValue }}</a>
                } @else {
                  {{ sale.item.serialNumber | defaultValue }}
                }
              </dd>

              @if (showCustomer) {
                <dt data-testid='sale-customername-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.CUSTOMER_NAME' | translate }}</dt>
                <dd data-testid='sale-customername' class="value pt-3 pb-3">
                  @if (sale.customerId && allowViewCustomer) {
                    <a [routerLink]="['/customers/', sale.customerId]" class="inline-flex items-center link">{{
                    sale.customerFullName | defaultValue }}</a>
                  } @else {
                    {{ sale.customerFullName | defaultValue }}
                  }
                </dd>
                <dt data-testid='sale-customeremail-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.CUSTOMER_EMAIL' | translate }}</dt>
                <dd data-testid='sale-customeremail' class="value pt-3 pb-3">
                  {{ sale.customerEmail | defaultValue }}
                </dd>
              }


              @if (companyHasCpo) {
                <dt data-testid='sale-iscpo-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.CPO' | translate }}</dt>
              }
              @if (companyHasCpo) {
                <dd data-testid='sale-iscpo' class="value pt-3 pb-3">
                  {{ sale.item.isCpo | friendlyBoolean }}
                </dd>
              }

              @if (showIsLegacyField) {
                <dt data-testid='sale-islegacy-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.IS_LEGACY' | translate }}</dt>
                <dd data-testid='sale-islegacy' class="value pt-3 pb-3">{{ sale.isLegacy | friendlyBoolean }}</dd>
              }

              @if (canViewPrice) {
                <dt data-testid='sale-price-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.PRICE' | translate }}</dt>
                <dd data-testid='sale-price' class="value pt-3 pb-3">@if (sale.price !== null) {
                  <span>{{ sale.price | defaultValue }}</span>
                } @else {
                  <span class="no-data">{{ 'NO_DATA.SYMBOL' | translate }}</span>
                }</dd>
              }

              <ng-container>
                <dt data-testid='sale-isgift-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.IS_GIFT' | translate }}</dt>
                <dd data-testid='sale-isgift' class="value pt-3 pb-3">{{ sale.isGift | friendlyBoolean }}</dd>
              </ng-container>
            </dl>
          </div>

          <div class="col-12 col-sm-12 mt-4">
            <h4 data-testid='sale-product-details'>{{ 'SALE_SINGLE_VIEW.PRODUCT_DETAILS' | translate }}</h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
            <dl class="details-grid">
              <dt data-testid='sale-productname-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.PRODUCT_NAME' | translate | defaultValue }}</dt>
              <dd data-testid='sale-productname' class="value pt-3 pb-3">
                @if (allowViewProduct) {
                  <a [routerLink]="['/products/', sale.item.product.id]" class="inline-flex items-center link">{{ sale.item.product.name | defaultValue }}</a>
                } @else {
                  {{ sale.item.product.name | defaultValue }}
                }
              </dd>

              <dt data-testid='sale-sku-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.PRODUCT_SKU' | translate }}</dt>
              <dd data-testid='sale-sku' class="value pt-3 pb-3">{{ sale.item.product.sku | defaultValue }}</dd>
            </dl>
          </div>

          @if (sale.item.productCustomisation) {
            <div class="col-12 col-sm-12 mt-4">
              <h4 data-testid='sale-productcustomisations'>{{ 'PRODUCT_CUSTOMIZATIONS.VIEW_PRODUCT_CUSTOMIZATIONS_DETAILS' | translate }}</h4>
              <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              <div class="row">
                <div class="col-12 col-md-4 col-lg-3">
                  <img data-testid='sale-productcustomisation-imageurl' src="{{ sale.item.productCustomisation.imageUrl }}" class="w-100 mt-2 mb-2 customisation-image featured-image">
                </div>
                <div class="col-12 col-md-8 col-lg-9">
                  <dl class="details-grid">
                    <dt data-testid='sale-productcustomisation-name-label' class="label grid-cols-1 pt-3">{{
                      'PRODUCT_CUSTOMIZATIONS_CREATE.NAME' | translate }}</dt>
                    <dd data-testid='sale-productcustomisation-name' class="value pt-3 pb-3">
                      @if (sale.item.productCustomisation && allowViewProductCustomisation) {
                      <a [routerLink]="['/product-customisations/', sale.item.productCustomisation.id]" class="inline-flex items-center link">
                        {{ sale.item.productCustomisation.name | defaultValue }}
                      </a>
                      } @else {
                        {{ sale.item.productCustomisation.name | defaultValue }}
                      }
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          }

      @if (sale.warranty) {
        <div class="col-12 col-sm-12 mt-4">
          <h4 data-testid='sale-warrantydetails'>{{ 'SALE_SINGLE_VIEW.WARRANTY_DETAILS' | translate }}</h4>
          <hr role="presentation" class="w-full mb-2 mt-3 border-t">
          <dl class="details-grid">
            <dt data-testid='sale-warrantycode-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.WARRANTY_CODE' | translate | defaultValue }}</dt>
            <dd data-testid='sale-warrantycode' class="value pt-3 pb-3">
              @if (sale.warranty.id && allowViewWarranty) {
                <a [routerLink]="['/warranties/', sale.warranty.id]" class="inline-flex items-center link">{{ sale.warranty.code | defaultValue }}</a>
              } @else {
                {{ sale.warranty.code | defaultValue }}
              }
            </dd>
            <dt data-testid='sale-warrantyperiod-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.WARRANTY_PERIOD' | translate }}</dt>
            <dd data-testid='sale-warrantyperiod' class="value pt-3 pb-3">
              <span data-testid='sale-warranty-activationdate' class="date">{{ sale.warranty.activationDate | date: 'dd-MM-yyyy HH:mm' }}</span> -
              <span data-testid='sale-warranty-enddate' class="date">{{ sale.warranty.endDate | date: 'dd-MM-yyyy HH:mm' }}</span>
            </dd>
            <dt data-testid='sale-warranty-isactive'class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.IS_ACTIVE' | translate }}</dt>
            <dd class="value pt-3 pb-3">{{ sale.warranty.isActive | friendlyBoolean }}</dd>
            <dt data-testid='sale-warranty-isextended'class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.IS_EXTENDED' | translate }}</dt>
            <dd class="value pt-3 pb-3">{{ sale.warranty.isWarrantyExtended | friendlyBoolean }}</dd>
            @if (companyIsPrepaired) {
              <dt data-testid='sale-warranty-isprepaired-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.IS_PREPAIRED' | translate }}</dt>
            }
            @if (companyIsPrepaired) {
              <dd data-testid='sale-warranty-isprepaired' class="value pt-3 pb-3">{{ sale.warranty.isPrepaired | friendlyBoolean }}</dd>
            }
            <dt data-testid='sale-warranty-timesused-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.TIMES_USED' | translate }}</dt>
            <dd data-testid='sale-warranty-timesused' class="value pt-3 pb-3">{{ sale.warranty.timesUsed }}</dd>
          </dl>
        </div>
      }

      <div class="col-12 col-sm-12 mt-4">
        <h4 data-testid='sale-retailer-details'>{{ 'SALE_SINGLE_VIEW.RETAILER_DETAILS' | translate }}</h4>
        <hr role="presentation" class="w-full mb-2 mt-3 border-t">
        <dl class="details-grid">
          <dt data-testid='sale-market-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.MARKET' | translate }}</dt>
          <dd data-testid='sale-market'class="value pt-3 pb-3">
            @if (sale.marketId && allowViewMarket) {
              <a [routerLink]="['/markets/', sale.marketId]" class="inline-flex items-center link">{{ sale.marketName | defaultValue }}</a>
            } @else {
              {{ sale.marketName | defaultValue }}
            }
          </dd>

          @if (showDistributionChannel) {
          <dt data-testid='sale-distributionchannel-label' class="label grid-cols-1 pt-3">{{ 'RETAILER_SINGLE_VIEW.DISTRIBUTION_CHANNEL' | translate }}</dt>
          <dd data-testid='sale-distributionchannel' class="value pt-3 pb-3">
            @if (allowViewDistributionChannel) {
              <a [routerLink]="['/distribution-channels/', sale.distributionChannel.id]" class="inline-flex items-center link">{{ sale.distributionChannel.name | defaultValue }}</a>
            } @else {
              {{ sale.distributionChannel.name | defaultValue }}
            }
          </dd>
          }

          <dt data-testid='sale-retailername-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.RETAILER_NAME' | translate }}</dt>
          <dd data-testid='sale-retailername' class="value pt-3 pb-3">
            @if (sale.retailerId && allowViewRetailer) {
              <a [routerLink]="['/retailers/', sale.retailerId]" class="inline-flex items-center link">{{ sale.retailerName | defaultValue }}</a>
            } @else {
              {{ sale.retailerName | defaultValue }}
            }
          </dd>

          <dt data-testid='sale-seller-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.SELLER' | translate }}</dt>
          <dd data-testid="sale-seller" class="value pt-3 pb-3">
            @if (sale.unregisteredUserFullName) {
              {{ sale.unregisteredUserFullName | defaultValue }}
            } @else {
              @if (sale.userFullName) {
                @if (allowViewUser) {
                  <a [routerLink]="['/users/', sale.userId]" class="inline-flex items-center link">
                    {{ sale.userFullName | defaultValue }}
                  </a>
                } @else {
                  {{ sale.userFullName | defaultValue }}
                }
              } @else {
                {{ null | defaultValue }}
              }
            }


          </dd>

          <!-- <dt class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.SELLER_ROLE' | translate }}</dt>
          <dd class="value pt-3 pb-3">
            <span class="flex items-center mr-2">{{ sale.seller?.userRoles | userRole }}</span>
          </dd> -->
        </dl>
      </div>

      @if (sale.isReturned) {
        <div class="col-12 col-sm-12 mt-4">
          <h4 data-testid='sale-return-details'>{{ 'SALE_SINGLE_VIEW.RETURN_DETAILS' | translate }}</h4>
          <hr role="presentation" class="w-full mb-2 mt-3 border-t">
          <dl class="details-grid">
            <dt data-testid='sale-returndate-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.RETURN_DATE' | translate }}</dt>
            <dd data-testid='sale-returndate' class="value pt-3 pb-3">{{ sale.returnDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>
            <dt data-testid='sale-comment-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.COMMENT' | translate }}</dt>
            <dd data-testid='sale-comment' class="value pt-3 pb-3">{{ sale.comment | defaultValue }}</dd>
          </dl>
        </div>
      }
    </section>
    <!-- /main content -->
  </div>
</div>
</div>
</div>
</div>
</div>


<!-- Modalbox: sale return -->
<p-dialog
  [header]="'MODALBOXES.TITLE_RETURN_SALE' | translate"
  [(visible)]="displayReturnSaleModalbox"
  [modal]="true"
  (onHide)="onHideSaleReturnAction()"
  [blockScroll]="true"
  [draggable]="false"
  [closable]="true"
  [resizable]="false"
  #returnSaleDialog>
  <form [formGroup]="saleReturnFormGroup">
    <div class="row">
      <div class="field-wr col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label data-testid='sale-return-search-label' class="block text-sm" for="retailers-selection">{{ 'WARRANTY_ACTIVATION.SEARCH_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="retailer"
          [placeholder]="'WARRANTY_ACTIVATION.SELECT_RETAILER_PLACEHOLDER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="false"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailer"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
      @if (companyHasCpo) {
        <div class="field-wr col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
          <label for="markAsCpo">{{ 'MODALBOXES.LABEL_SET_MARK_AS_CPO' | translate }} </label>
          <label data-testid="mark-as-cpo-yes-label" class="inline-flex mr-6">
            <p-radioButton data-testid="mark-as-cpo-yes" name="markAsCpo" value="true" formControlName="markAsCpo" inputId="yes" />
            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
          </label>
          <label data-testid="mark-as-cpo-no-label" class="inline-flex mr-2">
            <p-radioButton data-testid="mark-as-cpo-no" name="markAsCpo" value="false" formControlName="markAsCpo" inputId="no" />
            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
          </label>
        </div>
      }
      <div class="field-wr col-12 col-sm-12 col-md-12">
        <label data-testid='sale-return-reason-label' for="returnReason">{{ 'MODALBOXES.LABEL_RETURN_REASON' | translate }}</label>
        <textarea data-testid='sale-return-reason' class="text-sm" formControlName="returnReason" rows="3" placeholder="{{ 'MODALBOXES.RETURN_REASON_PLACEHOLDER' | translate }}" id="returnReason"></textarea>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid='sale-return-cancel-btn' type="button" class="btn outline-btn" (click)="onCancelSaleReturn()">{{ 'MODALBOXES.BTN_CANCEL_RETURN' | translate }}</button>
    <button data-testid='sale-return-btn' type="button" class="btn primary-btn" (click)="onSaleReturn()" [disabled]="saleReturnFormGroup.invalid">{{ 'MODALBOXES.BTN_RETURN_SALE' | translate }}</button>
  </ng-template>
</p-dialog>

